module.exports = __webpack_public_path__ + "img/kargonomi.c1e835b5.png";